import { TranslateFnType } from 'store'
import { GenderType } from 'store/features/user/types'

export const translateGender = (
  t: TranslateFnType,
  gender: GenderType,
): string => {
  switch (gender) {
    case 'female':
      return t('Frauen')
    case 'male':
      return t('Männer')
    case 'kids':
      return t('Kinder')
  }
}
